import { LicenseInfo } from '@mui/x-license';
import i18next from 'i18next';
import moment from 'moment';

import 'moment/locale/es';

import { handleLogout } from '../services/auth';
import initializeAndUseI18n from '../services/i18n';
import { checkLastActionCounter } from '../services/user-auth';

import { loadAppInfo } from './appInfo';

LicenseInfo.setLicenseKey(
  '646122f402bd00d01aa07384b2c4688aTz0xMzEwODUsRT0xODE4MjAxNTk5MDAwLFM9cHJlbWl1bSxMTT1hbm51YWwsUFY9aW5pdGlhbCxLVj0y'
);

checkLastActionCounter(function() {
  handleLogout();
});

const appInfo = await loadAppInfo();

const i18nt = await initializeAndUseI18n(appInfo);

const currentLocale = i18next.resolvedLanguage || 'en';

moment.locale('en');

export { appInfo, currentLocale, i18nt };
